import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { motion } from 'framer-motion';

const ModernList = ({
  items = [],
  type = 'bullet', // bullet, number, icon
  spacing = 2,
  align = 'left',
  heading,
  headingLevel = 5,
  ...props
}) => {
  const motionProps = {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.5 }
  };

  // Render each item as a glassy animated card
  const renderList = (list) => (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: spacing, textAlign: align }}>
      {list.map((item, idx) => {
        if (typeof item === 'string') {
          return (
            <Paper
              key={idx}
              elevation={2}
              component={motion.div}
              {...motionProps}
              sx={{
                p: 2,
                bgcolor: 'background.paper',
                borderRadius: 3,
                boxShadow: 3,
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                minHeight: 48,
              }}
            >
              {type === 'number' ? (
                <Typography variant="body2" color="primary" sx={{ fontWeight: 700, mr: 2 }}>{idx + 1}.</Typography>
              ) : null}
              <Typography variant="body1" sx={{ fontWeight: 500 }}>{item}</Typography>
            </Paper>
          );
        } else if (typeof item === 'object' && item.text) {
          return (
            <Paper
              key={idx}
              elevation={2}
              component={motion.div}
              {...motionProps}
              sx={{
                p: 2,
                bgcolor: 'background.paper',
                borderRadius: 3,
                boxShadow: 3,
                display: 'flex',
                alignItems: 'flex-start',
                gap: 2,
                minHeight: 48,
                flexDirection: 'column',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                {item.icon && <Box sx={{ mr: 1 }}>{item.icon}</Box>}
                <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>{item.text}</Typography>
              </Box>
              {item.children && Array.isArray(item.children) && (
                <Box sx={{ mt: 1, pl: 3 }}>
                  {item.children.map((child, cidx) => (
                    <Typography key={cidx} variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>{child}</Typography>
                  ))}
                </Box>
              )}
            </Paper>
          );
        }
        return null;
      })}
    </Box>
  );

  return (
    <Box sx={{ width: '100%', mb: spacing }} {...props}>
      {heading && (
        <Typography variant={`h${headingLevel}`} sx={{ fontWeight: 700, mb: 2, color: 'primary.main' }}>
          {heading}
        </Typography>
      )}
      {renderList(items)}
    </Box>
  );
};

export default ModernList;
